'use client';
import { useEffect, useState } from 'react';

import { BlockReferenceArray } from '@/cms';
import { ScrapingTemplateCardProps } from '@/blocks/ScrapingTemplateLibrary/Components/ScrapingTemplateCard';
import ScrapingTemplatePreviewCard from '@/blocks/ScrapingTemplatesPreview/Components/ScrapingTemplatePreviewCard';
import VerticalCarousel from '@/blocks/ScrapingTemplatesPreview/VerticalCarousel';
import { MAX_COLUMNS } from '../consts';

type CardItem = NonNullable<
  BlockReferenceArray<ScrapingTemplateCardProps>['data']
>[number];

type Props = {
  scrapingTemplateCards: CardItem[];
};

const ScrapingTemplatesPreviewClientCarousel = ({
  scrapingTemplateCards,
}: Props) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;
  const getOrderedCardsForColumnIndex = (columnIndex: number) => {
    const itemsPerColumn = Math.ceil(
      scrapingTemplateCards.length / MAX_COLUMNS
    );

    const cardSets = Array.from({ length: MAX_COLUMNS }).map((_, i) =>
      (scrapingTemplateCards || []).slice(
        i * itemsPerColumn,
        (i + 1) * itemsPerColumn
      )
    );

    const column1 = [...cardSets[0], ...cardSets[1], ...cardSets[2]];
    const column2 = [...cardSets[1], ...cardSets[2], ...cardSets[0]].reverse();
    const column3 = [...cardSets[2], ...cardSets[0], ...cardSets[1]];

    return [column1, column2, column3][columnIndex];
  };

  return Array.from({ length: MAX_COLUMNS }).map((_, index) => (
    <VerticalCarousel<CardItem>
      items={getOrderedCardsForColumnIndex(index)}
      renderItem={(card) => (
        <ScrapingTemplatePreviewCard card={card.attributes} />
      )}
      key={index}
      direction={index % 2 === 0 ? 'up' : 'down'}
      classNames={{
        inner: 'group-hover:animation-pause transition-delay-500',
      }}
    />
  ));
};

export default ScrapingTemplatesPreviewClientCarousel;
